<template>
  <div>
    <div class="form_container" v-if="!success">
      <h2 class="mb-4 text-4xl border-b pb-3">We're almost done</h2>
      <p class="font-bold">Add your details below to join the event</p>
      <FormulateForm
        class="form"
        @submit="submit"
        validation="blur"
        #default="{ isValid }"
        v-model="form"
      >
        <FormulateInput
          name="name"
          type="text"
          class="mt-4"
          placeholder="Your name"
          validation="required"
        />
        <FormulateInput
          name="email"
          type="email"
          class="my-4"
          placeholder="Your email address"
          validation="bail|email"
          :validation-messages="{
            email: 'Please enter a valid email address',
          }"
        />
        <div class="contribute flex w-full">
          <input
            type="checkbox"
            id="subscribe"
            v-model="host"
            name="host"
            checked
          />
          <label for="host">Would you be interested in hosting a game? <br /> <a href="https://edgeryders.eu/t/host-a-game-of-witness/16168" target="_blank">Find out more</a>.</label>
        </div>
        <div class="contribute flex w-full" >
          <input
            type="checkbox"
            id="subscribe"
            v-model="story"
            name="story"
            checked
          />
          <label for="story">Do you want to write a story for Witness? <br /><a href="https://edgeryders.eu/t/the-scifi-economics-lab-is-commissioning-writers-to-inspire-a-storytelling-contest-that-explores-better-futures/16205" target="_blank">Find out more</a>.</label>
        </div>
        <div class="subscribe flex w-full">
          <input
            type="checkbox"
            id="subscribe"
            v-model="newsletter"
            name="subscribe"
            checked
          />
          <label for="subscribe">Subscribe to Witness newsletter</label>
        </div>
        <FormulateInput
          type="submit"
          :wrapper-class="['submit']"
          :disabled="!isValid"
          label="Submit"
        />
      </FormulateForm>
    </div>
    <div class="nav_bar justify-start pl-20">
      <button class="back" @click="previousStep()">
        Previous
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Form",
  data: () => ({
    name: null,
    newsletter: false,
    story: false,
    host: false,
    errors: null,
    email: [],
    form: {
      name: null,
      email: null,
    },
    success: false,
  }),
  methods: {
    submit() {
      this.sendForm();

      if (this.newsletter) {
        this.subscribe();
      }
      this.$store.success = true;
      var self = this;
      var emailvalue = self.form.email;
      console.log(emailvalue);

      setTimeout(
        () =>
          this.$router.push({
            name: "Player",
            params: { id: emailvalue },
          }),
        2000
      );
    },
    sendForm() {
      var json = JSON.stringify({
        name: this.form.name,
        email: this.form.email,
        distrikt: this.$store.user.distrikt.id,
        cards: this.$store.user.cards,
        host: this.host,
        story: this.story
      });
      var self = this;
      fetch("/.netlify/functions/form", {
        method: "Post",
        body: json,
      })
        .then(function(response) {
          // handle success
          return response.json();
        })
        .then(function(data) {
          console.log(data);
          self.createScoreCard(data);
        })
        .catch(function(error) {
          // handle error
          window.console.log(error);
        });
    },
    createScoreCard(data) {
      console.log(data);
      var self = this;
      fetch("/.netlify/functions/hello", {
        method: "Post",
        body: JSON.stringify(data),
      })
        .then(function(response) {
          // handle success
          return response.json();
        })
        .then(function(data) {
          console.log(data);
          self.$store.user.scorecard = data.url;
          self.success = true;
        })
        .catch(function(error) {
          // handle error
          window.console.log(error);
        });
    },
    subscribe() {
      var json = JSON.stringify({
        name: this.form.name,
        email: this.form.email,
      });
      console.log(json);
      fetch("/.netlify/functions/subscribe", {
        method: "Post",
        body: json,
      })
        .then(function(response) {
          // handle success
          window.console.log(response);
        })
        .catch(function(error) {
          // handle error
          window.console.log(error);
        });
    },
  },
  async created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h2 {
  font-family: "EB Garamond", serif;
  animation: fadeup 0.75s ease forwards;
  opacity: 0;
}
p {
  animation: fadeup 0.75s ease 0.1s forwards;
  opacity: 0;
}
div /deep/ .formulate-input-wrapper {
  input {
    border: 0.5px solid #ddd;
    max-width: 350px;
    opacity: 0;
    width: 100%;
    @apply mx-auto p-3;
    animation: fadeup 0.75s ease 0.25s forwards;
    &:nth-child(2) {
      opacity: 0;
      animation: fadeup 0.75s ease 0.3s forwards;
    }
  }
}
.nav_bar {
  box-shadow: none;
}
.back {
  @apply font-bold pl-8 text-lg;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 125' style='enable-background:new 0 0 100 100' xml:space='preserve'%3E%3Cswitch%3E%3Cg%3E%3Cpath d='m4.1 53.8 30.6 30.6a5.3 5.3 0 0 0 7.5 0 5.3 5.3 0 0 0 0-7.5L20.7 55.3h71.5c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.3-5.3-5.3H20.7l21.5-21.5a5.3 5.3 0 0 0 0-7.5c-1-1-2.4-1.6-3.8-1.6s-2.7.5-3.8 1.6L4.1 46.2c-1 1-1.6 2.4-1.6 3.8s.6 2.8 1.6 3.8z'/%3E%3C/g%3E%3C/switch%3E%3C/svg%3E")
    4px 5px no-repeat;
  background-size: 15px;
  &:hover {
    cursor: pointer;
    @apply underline;
  }
}
.contribute {
  @apply border-t border-b p-4 mb-2 flex justify-center;
  input {
    @apply mr-2 ml-10 mt-1;
    &:hover {
      cursor: pointer;
    }
  }
  a {
    @apply font-bold underline;
    &:hover {
      cursor: pointer
    }
  }
}
.subscribe {
  max-width: 350px;
  width: 100%;
  @apply px-2 flex justify-center font-bold border-t border-b mb-3 py-3 mx-auto flex items-center rounded;
  input {
    @apply mr-2;
    &:hover {
      cursor: pointer;
    }
  }
}
div /deep/ .submit {
  button {
    background: black;
    width: 100px;
    color: white;
    text-decoration: none;
    @apply rounded-full font-bold mx-auto inline p-3 px-6 font-bold;
  }
  button[disabled] {
    background: #ddd;
  }
}

.form_container {
  @apply flex flex-col justify-center h-screen items-center;
}
h3 {
  text-decoration: underline;
}
.form {
  display: flex;
  flex-direction: column;
  width: 40%;
  max-width: 500px;
  input.text {
    margin-bottom: 20px;
    font-size: 1rem;
    padding: 10px;
  }
}
</style>
